/**
 * Типизированная версия Object.entries (подходит, если в качестве ключей - enum)
 * @param obj Объект
 * @typeParam T Тип объекта
 * @returns Массив элементов вида [key, value]
 * @example
 * ```ts
 * // Базовое использование с обычным объектом
 * const user = {
 *   name: 'John',
 *   age: 30,
 *   city: 'Moscow'
 * };
 *
 * const userEntries = entries(user);
 * // Тип: Array<['name' | 'age' | 'city', string | number]>
 * console.log(userEntries);
 * // [['name', 'John'], ['age', 30], ['city', 'Moscow']]
 * ```
 * @example
 * ```ts
 * // Использование с enum
 * enum UserRole {
 *   Admin = 'admin',
 *   User = 'user',
 *   Guest = 'guest'
 * }
 *
 * const rolePermissions = {
 *   [UserRole.Admin]: ['read', 'write', 'delete'],
 *   [UserRole.User]: ['read'],
 *   [UserRole.Guest]: []
 * };
 *
 * const permissionsEntries = entries(rolePermissions);
 * // Тип: Array<[UserRole, string[]]>
 * console.log(permissionsEntries);
 * // [
 * //   [UserRole.Admin, ['read', 'write', 'delete']],
 * //   [UserRole.User, ['read']],
 * //   [UserRole.Guest, []]
 * // ]
 * ```
 * @example
 * ```ts
 * // Сравнение с обычным Object.entries
 * const obj = { a: 1, b: 2, c: 3 };
 *
 * // Object.entries возвращает [string, unknown][]
 * const standardEntries = Object.entries(obj);
 * // Тип: [string, unknown][]
 *
 * // entries возвращает типизированный массив
 * const typedEntries = entries(obj);
 * // Тип: Array<['a' | 'b' | 'c', number]>
 *
 * // Типизация позволяет избежать ошибок
 * const firstEntry = typedEntries[0];
 * if (firstEntry) {
 *   const [key, value] = firstEntry;
 *   // key имеет тип 'a' | 'b' | 'c'
 *   // value имеет тип number
 * }
 * ```
 */
export function entries(obj) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return Object.entries(obj);
}
